import { useNavigate } from 'react-router-dom';
import Badge, { priorityTone } from '@/components/base/Badge';
import { useAppStore } from '@/store/AppStore';

interface QueueItem {
  key: string;
  time: string;
  title: string;
  subtitle: string;
  meta: string;
  priority: 'Yüksek' | 'Orta' | 'Normal';
  actionLabel: string;
  actionPath: string;
  actionIcon: string;
  accent: boolean;
}

export default function PriorityQueue() {
  const { requests, setRequestStatus } = useAppStore();
  const navigate = useNavigate();

  const items: QueueItem[] = [
    {
      key: 'job-villa',
      time: '10:00',
      title: 'Villa Temizliği',
      subtitle: 'Ayşe Yılmaz',
      meta: 'Beykoz · A Ekibi',
      priority: 'Normal',
      actionLabel: 'İşi Aç',
      actionPath: '/bugunun-isleri',
      actionIcon: 'ri-play-circle-line',
      accent: false,
    },
    {
      key: 'video-mehmet',
      time: 'Video Geldi',
      title: 'Mehmet Demir',
      subtitle: 'İnşaat Sonrası Temizlik',
      meta: 'Teklif hazırlanmadı',
      priority: 'Yüksek',
      actionLabel: 'Teklif Hazırla',
      actionPath: '/teklifler',
      actionIcon: 'ri-file-add-line',
      accent: true,
    },
    {
      key: 'reply-selin',
      time: 'Teklif Cevabı',
      title: 'Selin Kaya',
      subtitle: 'Teklif: 12.000 TL',
      meta: '2 gündür cevap yok',
      priority: 'Yüksek',
      actionLabel: 'Takip Et',
      actionPath: '/takip',
      actionIcon: 'ri-chat-3-line',
      accent: false,
    },
  ];

  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-white">
      <div className="flex items-center justify-between border-b border-background-100 px-5 py-4">
        <div className="flex items-center gap-2">
          <span className="h-2 w-2 rounded-full bg-accent-500" />
          <h2 className="font-heading text-[15px] font-bold text-foreground-950">Bugün Öncelikli</h2>
        </div>
        <span className="text-xs font-semibold text-foreground-400">{items.length} aksiyon</span>
      </div>

      <ul className="divide-y divide-background-100">
        {items.map((item) => (
          <li key={item.key} className="flex items-center gap-4 px-5 py-4 transition-colors hover:bg-background-50">
            <div className="w-16 shrink-0 text-xs font-semibold text-foreground-500">{item.time}</div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <span className="truncate text-sm font-semibold text-foreground-900">{item.title}</span>
                <Badge tone={priorityTone(item.priority)}>{item.priority}</Badge>
              </div>
              <div className="mt-0.5 truncate text-[13px] text-foreground-600">{item.subtitle}</div>
              <div className="truncate text-xs text-foreground-400">{item.meta}</div>
            </div>
            <button
              type="button"
              onClick={() => {
                if (item.key === 'video-mehmet') {
                  const req = requests.find((r) => r.customerName === 'Mehmet Demir');
                  if (req) setRequestStatus(req.id, 'Teklif Hazırlanacak');
                }
                navigate(item.actionPath);
              }}
              className={`flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md px-3 py-2 text-[13px] font-semibold transition-colors ${
                item.accent
                  ? 'bg-accent-500 text-primary-950 hover:bg-accent-400'
                  : 'border border-background-200 text-foreground-700 hover:bg-background-100'
              }`}
            >
              <i className={`${item.actionIcon} text-sm`} />
              {item.actionLabel}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}